const ExtraWarantyIcon = ({ width = "16px", height = "16px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width={width}
    height={height}
  >
    <g fill="#000">
      <path d="m14.85 9.65-1.5-1.5a.5.5 0 0 0-.7 0L8 12.79V15h2.2l4.65-4.65a.5.5 0 0 0 0-.7ZM9.8 14H9v-.8l2.5-2.5.8.8L9.8 14Zm3.2-3.2-.8-.8.8-.8.8.8-.8.8ZM9 8H4v1h5V8Zm1-3H4v1h6V5Z" />
      <path d="M13 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v6.5a5.5 5.5 0 0 0 2.91 4.85l2.59 1.38V13.6l-2.12-1.13A4.5 4.5 0 0 1 2 8.5V2h10v4.5h1V2Z" />
    </g>
  </svg>
);

export default ExtraWarantyIcon;
